module.exports = __webpack_public_path__ + "static/media/Northville-Hollow-Bylaws.348f4198.pdf";